import React, { FC, useState } from 'react'
import { Wrapper, Input, Label, Span } from './style'

interface IRadioGroup {
  header: string
  fields: Array<{ name: string, value: string }>
  checked?: string | undefined
  onChange: <T>(value: T) => void
}

export const RadioGroup: FC<IRadioGroup> = ({ header, fields, onChange, checked }) => {
    const [activeInput, setActiveInput] = useState(checked)

  const changeHandle = e => {
    setActiveInput(e.target.value)
    onChange(e.target.value)
  }

  return (
    <Wrapper>
      <label>{header}</label>
      {fields.map(i => (
        <Label key={i.value}>
          <Input
            type="radio"
            id={i.value}
            value={i.value}
            onChange={changeHandle}
            checked={activeInput === i.value}
          />
          <Span>{i.name}</Span>
        </Label>
      ))}
    </Wrapper>
  )
}
